import { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
	GetLanguageValue,
	Translate,
} from "@/components/Application/Translate";
import {
	Modal,
	ModalContent,
	ModalFooter,
	ModalHeader,
} from "@/components/Modal/Modal";

import { ProcedureNodeStep } from "@/model/Procedure/ProcedureNodeStep";
import { UpdateStepStatusRequest } from "@/model/Procedure/UpdateStepStatusRequest";
import { TranslationContext } from "@/model/Translation/TranslationContext";

import { useUpdateStepStatus } from "@/service/ProcedureMutations";
import { RouteParams } from "@/service/Utilities";

interface IRemoveStepCheckedModal {
	activeSchemeId: number | undefined;
	show: boolean;
	step: ProcedureNodeStep;
	CloseModal: () => void;
}

export const RemoveStepCheckedModal: FC<IRemoveStepCheckedModal> = (props) => {
	const { id } = useParams<RouteParams>();

	const [errorMessage, setErrorMessage] = useState<string | undefined>();
	const [comment, setComment] = useState("");

	const updateProcedureDetailStepState = useUpdateStepStatus();

	const translationContext = useContext(TranslationContext);

	const CleanState = () => {
		setComment("");
		setErrorMessage("");
	};

	const CloseModal = () => {
		CleanState();
		props.CloseModal();
	};

	const Save = async () => {
		const request: UpdateStepStatusRequest = {
			ArchiveType: "Comment",
			ProcedureId: parseInt(id),
			SchemeId: props.activeSchemeId,
			Status: 0,
			StepId: props.step.Id,
			Value: comment,
		};

		if (!comment || /^\s*$/.test(comment)) {
			const error = GetLanguageValue(
				translationContext,
				"Procedure.CommentOverlay.RemoveStepChecked.ReasoneRemoveCheckMark",
				"Comment cannot be empty.",
			);
			console.error(error);
			setErrorMessage(error?.value?.toString());
			return;
		}

		const response = await updateProcedureDetailStepState(request);

		if (response?.Success) {
			CleanState();
			props.CloseModal();
		} else {
			console.error("failure", response);
			setErrorMessage(response?.ErrorMessage);
		}
	};

	useEffect(() => {
		const close = (e: { key: string }) => {
			if (e.key === "Escape") {
				CleanState();
				props.CloseModal();
			}
		};
		window.addEventListener("keydown", close);
		return () => window.removeEventListener("keydown", close);
	}, []);

	return (
		<Modal show={props.show} CloseModal={CloseModal}>
			<ModalHeader CloseModal={CloseModal}>
				<Translate
					HTMLTag="h2"
					String="Procedure.CommentOverlay.RemoveStepChecked.ResetStep"
				>
					Reset step
				</Translate>
			</ModalHeader>
			<ModalContent errorMessages={errorMessage}>
				<div className="row-one-column">
					<div>
						<Translate
							htmlFor="reason"
							HTMLTag="label"
							String="Procedure.CommentOverlay.RemoveStepChecked.ReasoneRemoveCheckMark"
						>
							Reason for removing checkmark
						</Translate>
						<textarea
							name="reason"
							onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
								setComment(e.target.value)
							}
							value={comment}
						></textarea>
					</div>
				</div>
			</ModalContent>
			<ModalFooter Save={Save} />
		</Modal>
	);
};
